import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BasePagingResponse } from "../_types";

export type GetMerchantLimitRequest = {
    page?: number;
    size?: number;
    orderByDesc?: boolean;
    orderBy?: string;
    merchantId: number;
    [key: string]: string | number | boolean | undefined;
}

export type IMerchantLimits = {
    merchantName: string;
    merchantId: number;
    limit: number;
    extraLimit: number;
    usedLimit: number;
    limitExcessCount: number;
    startDate: string;
    finishDate: string;
    id: number;
    isEditable: boolean;
    status: string;
    systemDate: string;
    createDate: string;
    createUserId: number;
    updateDate: string;
    updateUserId: number;
    deleteDate?: string;
    deleteUserId: number;
}

export type GetMerchantLimitResponse = BasePagingResponse<Array<IMerchantLimits>>;

async function getMerchantLimitList(data: GetMerchantLimitRequest): Promise<GetMerchantLimitResponse> {
    try {
        return (await axiosInstance.post("/MerchantLimits/ListByMerchantId", data))
            .data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useGetMerchantLimits() {
    return useMutation<GetMerchantLimitResponse, Error, GetMerchantLimitRequest>((variables) =>
        getMerchantLimitList(variables)
    );
}
